module.exports = __webpack_public_path__ + "img/closePopup.6670b9ab.png";